import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { datePhpFormat2, mdf } from "../utils/functions";

export default function Timer() {
  const drawWeeks = useSelector((state) => state.fourDPlaceBet.drawWeeks);
  // const draw = useSelector((state) => state.draw);
  var [d, setDate] = useState(new Date());
  // const cutOff = useSelector((state) => state.drawSet.set.cutOff2);
  const cutOff = process.env.REACT_APP_CUT_OFF;

  useEffect(() => {
    var timer = null;
    timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });

  const lookForWed = (currentDate) => {
    let endTime = new Date(currentDate);
    endTime.setDate(endTime.getDate() + 7);

    let dat = [];
    for (let ctr = currentDate; ctr <= endTime; ) {
      if (ctr.getDay() === 3) {
        dat.push(new Date(ctr));
        break;
      }
      ctr.setDate(ctr.getDate() + 1);
    }
    return dat;
  };

  const lookForSat = (currentDate) => {
    let endTime = new Date(currentDate);
    endTime.setDate(endTime.getDate() + 7);

    let dat = [];
    for (let ctr = currentDate; ctr <= endTime; ) {
      if (ctr.getDay() === 6) {
        dat.push(new Date(ctr));
        break;
      }
      ctr.setDate(ctr.getDate() + 1);
      // console.log(ctr.getDate());
    }
    return dat;
  };

  const lookForSun = (currentDate) => {
    let endTime = new Date(currentDate);
    endTime.setDate(endTime.getDate() + 7);

    let dat = [];
    for (let ctr = currentDate; ctr <= endTime; ) {
      if (ctr.getDay() === 0) {
        dat.push(new Date(ctr));
        break;
      }
      ctr.setDate(ctr.getDate() + 1);
    }
    return dat;
  };

  const lookFor6Draw = (currentDate) => {
    let endTime = new Date(currentDate);
    endTime.setDate(endTime.getDate() + 21);

    let dat = [];
    for (let ctr = currentDate; ctr <= endTime; ) {
      if (ctr.getDay() === 0 || ctr.getDay() === 6 || ctr.getDay() === 3) {
        dat.push(new Date(ctr));
      }
      if (dat.length === 6) {
        break;
      }
      ctr.setDate(ctr.getDate() + 1);
    }

    return dat;
  };

  const gettingDate = () => {
    let currentTime = parseInt(d.getHours() + "" + mdf(d.getMinutes()));

    // add 1
    if (cutOff <= currentTime) {
      d.setDate(d.getDate() + 1);
    }

    // console.log(process.env.REACT_APP_BASE_URL);
    // console.log(cutOff);
    // console.log(process.env.REACT_APP);
    // console.log(currentTime);

    let dateList = [];

    if (drawWeeks?.indexOf("Wed") > -1)
      dateList = [...dateList, ...lookForWed(new Date(d))];

    if (drawWeeks?.indexOf("Sat") > -1)
      dateList = [...dateList, ...lookForSat(new Date(d))];

    if (drawWeeks?.indexOf("Sun") > -1)
      dateList = [...dateList, ...lookForSun(new Date(d))];

    if (drawWeeks?.indexOf("6 Draws") > -1)
      dateList = [...dateList, ...lookFor6Draw(new Date(d))];

    dateList.sort(function (a, b) {
      return new Date(a) - new Date(b);
    });

    return dateList.map((e, eI) => {
      return <div key={eI}>{datePhpFormat2(new Date(e))}</div>;
    });
  };

  // return <div>{JSON.stringify(drawWeeks)}</div>;
  return gettingDate();
}
